import styled from "styled-components";
export var Chart = styled.div.withConfig({
  displayName: "timelinestyles__Chart",
  componentId: "sc-13tmrwy-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    display: flex;\n    width: 100%;\n\n    @media (max-width: ".concat(theme.breakpoints[2], "){\n      flex-direction: column;\n    }\n  ");
});
export var OrganizationsHolder = styled.div.withConfig({
  displayName: "timelinestyles__OrganizationsHolder",
  componentId: "sc-13tmrwy-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return "\n    width: 400px;\n    margin-bottom: 20px;\n\n    @media (max-width: ".concat(theme.breakpoints[4], "){\n      width: 300px;\n    }\n\n    @media (max-width: ").concat(theme.breakpoints[2], "){\n      width: 100%;\n    }\n  ");
});
export var GraphContainer = styled.div.withConfig({
  displayName: "timelinestyles__GraphContainer",
  componentId: "sc-13tmrwy-2"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme;
  return "\n    width: calc(100% - 400px);\n\n    @media (max-width: ".concat(theme.breakpoints[4], "){\n      width: calc(100% - 300px);\n    }\n\n    @media (max-width: ").concat(theme.breakpoints[2], "){\n      width: 100%;\n    }\n  ");
});